import React from 'react';
import styled from 'styled-components';

import IconSvgComponent from 'components/basic/icons/IconSvgComponent';
import Dropdown, { DropdownOption } from 'components/basic/inputs/Dropdown';
import { CoinIcon } from 'config/coinIcons/CoinIcon';
import { useSelector } from 'reduxState/store';

const Wrap = styled.div`
  width: 200px;
  .isMobileStyle & {
    width: initial;
  }
`;

export function MarketSearchDropdown({
  selectedMarket,
  onSelect,
  disabled,
}: {
  selectedMarket?: string;
  onSelect: (market: string) => void;
  disabled?: boolean;
}) {
  const listedMarketsList = useSelector(
    state => state.markets.listedMarkets.listedMarketsList
  );

  const options: DropdownOption<string>[] = [
    {
      label: 'All Markets',
      icon: (
        <IconSvgComponent
          inline
          css={{ height: 12, margin: '0 8px 0 0' }}
          icon="union"
        />
      ),
      iconSelected: false,
      value: '',
    } as DropdownOption<string>,
  ].concat(
    listedMarketsList.map(market => {
      const symbol = market.split('-')[0];
      return {
        label: market,
        icon: <CoinIcon symbol={symbol} size="12px" margin="0 8px 0 0" />,
        iconSelected: false,
        value: market,
      };
    })
  );

  return (
    <Wrap>
      <Dropdown<string>
        options={options}
        initialText="Filter by Market"
        selected={selectedMarket || undefined}
        disabled={disabled}
        onChange={onSelect}
      />
    </Wrap>
  );
}
